import type { CandidateVacancy } from '../types';

type CandidateEconomicActivity = NonNullable<
  CandidateVacancy['company']
>['economicActivities'][number];

export function mockCandidateEconomicActivity(
  overrides: Partial<CandidateEconomicActivity> = {}
): CandidateEconomicActivity {
  return {
    id: 1,
    code: '6201',
    name: 'Computer programming activities',
    ...overrides,
  };
}
